module.exports = __webpack_public_path__ + "img/ITUNES.d398c8b2.png";